import { CompositeMeterData } from '@models/meter-scans/composite/composite-meter-data';
import {OTDRData} from '@models/meter-scans/otdr-data';

export class ItuSearchData extends CompositeMeterData {
  hardwareVersion: string;
  mac: string;
  module: string;
  scanData: OTDRData[];

  constructor(
    httpResponse: ItuSearchData
  ) {
    super();
    this.timestamp = httpResponse.timestamp;
    this.mac = httpResponse.mac;
    this.hardwareVersion = httpResponse.hardwareVersion;
    this.longitude = httpResponse.longitude;
    this.latitude = httpResponse.latitude;
    this.scanData = httpResponse.scanData;
  }
}
